/**
 * Live viewer count for the product page.
 *
 * The number does a mean-reverting random walk: small steps, gently pulled back
 * toward the middle of the range. A plain random pick over the whole range reads
 * as obviously fake, and a pure random walk ends up pinned at min/max.
 */
(function () {
  var DEFAULTS = { min: 50, max: 150, step: 6, interval: 1 };
  var STORAGE_PREFIX = 'live-viewers:';

  function clamp(value, min, max) {
    return value < min ? min : (value > max ? max : value);
  }

  function readStored(key) {
    try {
      return parseInt(window.sessionStorage.getItem(key), 10);
    } catch (e) {
      return NaN;
    }
  }

  function writeStored(key, value) {
    try {
      window.sessionStorage.setItem(key, String(value));
    } catch (e) {
      // Private mode / storage blocked - the counter still runs.
    }
  }

  class LiveViewers extends HTMLElement {
    connectedCallback() {
      this.min = parseInt(this.dataset.min, 10) || DEFAULTS.min;
      this.max = parseInt(this.dataset.max, 10) || DEFAULTS.max;
      if (this.max < this.min) this.max = this.min;
      this.step = parseInt(this.dataset.step, 10) || DEFAULTS.step;
      this.interval = (parseFloat(this.dataset.interval) || DEFAULTS.interval) * 1000;

      this.output = this.querySelector('[data-viewer-count]');
      if (!this.output) return;

      this.storageKey = STORAGE_PREFIX + (this.dataset.key || 'default');
      var stored = readStored(this.storageKey);
      this.current = (stored >= this.min && stored <= this.max)
        ? stored
        : (parseInt(this.output.textContent, 10) || Math.round((this.min + this.max) / 2));

      this.render();
      this.timerId = setInterval(this.tick.bind(this), this.interval);
    }

    disconnectedCallback() {
      clearInterval(this.timerId);
    }

    tick() {
      // No point updating a tab nobody is looking at.
      if (document.hidden) return;

      var mid = (this.min + this.max) / 2;
      var span = (this.max - this.min) || 1;
      var pull = ((mid - this.current) / span) * this.step * 0.6;
      var noise = (Math.random() * 2 - 1) * this.step;
      var delta = Math.round(pull + noise);
      if (delta === 0) delta = Math.random() < 0.5 ? -1 : 1;

      this.current = clamp(this.current + delta, this.min, this.max);
      this.render();
    }

    render() {
      this.output.textContent = this.current;
      writeStored(this.storageKey, this.current);
    }
  }

  if (!window.customElements.get('live-viewers')) {
    window.customElements.define('live-viewers', LiveViewers);
  }
})();
